import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { queryList, queryCouponList, clearVoucherList } from './modules'
import Loading from 'components/Loading'
import { languageChange, queryKycStatus } from 'store/siteConfig'

export default function(route) {
  const List = Loadable({
    loader: () => import('./List'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          couponListState: state.couponListState,
          siteConfig: state.siteConfig
        }),
        {
          languageChange,
          queryKycStatus,
          queryList,
          queryCouponList,
          clearVoucherList
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/list`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <List {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
